import { Tag } from 'antd';
import i18next from 'i18next';
import { ReactNode } from 'react';

import {
  DIRECTION_TYPE,
  POSITION_TYPE,
  PROJECT_CHILD_ITEM_RESIDENCE_TYPE,
  PROJECT_CHILD_ITEM_STATUS,
  STATUS_COLORS_LIST,
} from '../commons/constants';

export const renderChildItemType = (key: string): ReactNode => {
  if (!key || !PROJECT_CHILD_ITEM_RESIDENCE_TYPE[key]) return null;

  return i18next.t(PROJECT_CHILD_ITEM_RESIDENCE_TYPE[key].label);
};

export const renderFormattedPrice = (props: {
  value: number;
  currency?: string;
  locale?: string;
}): ReactNode => {
  const { value, currency = 'VND', locale = i18next.language } = props;
  if (!value) return null;

  const parseByCurrencyStr = i18next.t('common.price-format', {
    localValue: value,
    formatParams: { localValue: { currency, locale } },
  });

  return parseByCurrencyStr.replaceAll(/\.|,/g, (match) => (match === ',' ? '.' : ',')).trim();
};

export const renderChildItemStatus = ({
  key,
  description,
}: {
  key: string;
  description?: string;
}): ReactNode => {
  if (!key || !PROJECT_CHILD_ITEM_STATUS[key]) return null;
  const status = PROJECT_CHILD_ITEM_STATUS[key];

  const color = !status.color
    ? STATUS_COLORS_LIST[Object.values(PROJECT_CHILD_ITEM_STATUS).findIndex((i) => i.key === key)]
    : status.color;
  return (
    <>
      <Tag color={color}>{i18next.t(PROJECT_CHILD_ITEM_STATUS[key].label)}</Tag>
      {description && <Tag color={color}>{description}</Tag>}
    </>
  );
};

export const renderDirectionType = (key: string): ReactNode => {
  if (!key || !DIRECTION_TYPE[key]) return null;

  return i18next.t(DIRECTION_TYPE[key].label);
};

export const renderPositionType = (key: string): ReactNode => {
  if (!key || !POSITION_TYPE[key]) return null;

  return i18next.t(POSITION_TYPE[key].label);
};
